export const messageActionTypes = {
    SET_NEW_MESSAGE: 'SET_NEW_MESSAGE'
};